import { render, staticRenderFns } from "./NewPost.vue?vue&type=template&id=10821bdb&scoped=true"
import script from "./NewPost.vue?vue&type=script&lang=js"
export * from "./NewPost.vue?vue&type=script&lang=js"
import style0 from "./NewPost.vue?vue&type=style&index=0&id=10821bdb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10821bdb",
  null
  
)

export default component.exports